import type { Product } from '@/entities/products/model/types/product';
import type { Category } from '@/entities/categories/model/types/categories';
import type { Locales } from '@/shared/model/types/locale';

function getSlug(obj: Category | Product, locale: Locales): string {
  return String(obj?.[`slug_${locale}`] || '');
}

export function generateProductDetailLink(
  product: Product,
  categories: Category[],
  locale: Locales,
  localePath: (path: string) => string
): string {

  const parentCategoryId = product?.category?.parent || product?.category?.id;

  const category = categories.find(cat => cat.id === parentCategoryId) || {
    id: 0,
    name: '',
    icon: '',
    link: '',
  };

  const subcategory = categories.find(cat => cat?.parent === parentCategoryId) || {
    id: 0,
    name: '',
    icon: '',
    link: '',
  };

  const categorySlug = getSlug(category, locale);
  const subcategorySlug = getSlug(subcategory, locale);
  const productSlug = getSlug(product, locale);

  if (!categorySlug || !productSlug) {
    return '#';
  }

  return subcategorySlug ? localePath(`/catalog/${categorySlug}/${subcategorySlug}/product-${productSlug}`) : localePath(`/catalog/${categorySlug}/product-${productSlug}`);
}
